import { ReactNode, useCallback, useState } from 'react';
import { TemplateCanje } from './TemplateCanje';
import { CANJE_INVITADOS_TITLE, CANJE_BUTTON_TEXT } from '../shared/Constantes';
import { IndexValue } from '../../types/IndexValue';
import { InvitadosControls } from './InvitadosControls';
import { InvitadosComponent } from './InvitadosComponent';
import { TemplateForm } from './TemplateForm';
import { FormChildProps } from '../../types/FormChildProps';
import { GetInvitadosPayload } from '../shared/GetPayload';
import { canjeMutation } from '../../rest/mutations/canje.post';
import { Mutations } from '../../rest/Mutations';
import { useMutation } from '@apollo/client';
import { Spinner } from '../shared/Spinner';
import { GenericErrorHandler, TMRandRetryErrorHandler } from '../shared/GenericErrorHandler';
import { ResponseCanje } from '../../rest/models/ResponseCanje';
import { InvitadosConfirmacion } from './InvitadosConfirmacion';

type FormInvitadosProps = {
  canjeCallback: (res: boolean | undefined) => void;
  handleError: (message?: string) => void;
  cantMaxInvitados: number;
  token: string | undefined;
};

export const FormInvitados = (props: FormInvitadosProps) => {
  const [invitados, setInvitados] = useState<((props: FormChildProps) => ReactNode)[]>([]);
  const [validate, { loading }] = useMutation<Mutations>(canjeMutation);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [formCache, setFormCache] = useState<IndexValue>();
  const [msg, setMsg] = useState<string | null>(null);

  const handleError = useCallback(
    (error: any) => {
      return TMRandRetryErrorHandler(error) === null
        ? GenericErrorHandler(props.handleError, error)
        : setMsg(TMRandRetryErrorHandler(error));
    },
    [props.handleError]
  );

  const canjeService = async (data: IndexValue) => {
    await validate({ variables: { input: GetInvitadosPayload(data, props.token, props.cantMaxInvitados) } })
      .then((x) => props.canjeCallback((x?.data as ResponseCanje).canjeResponse?.result))
      .catch((x) => handleError(x));
  };

  const addInvitado = () => {
    setInvitados([...invitados, InvitadosComponent]);
  };

  const sliceInvitado = () => {
    setInvitados((previousArr) => previousArr.slice(0, -1));
  };

  if (loading) return <Spinner />;

  const controls = (
    <InvitadosControls
      addInvitado={addInvitado}
      sliceInvitado={sliceInvitado}
      cantMaxInvitados={props.cantMaxInvitados}
      cantInvitados={invitados.length}
    />
  );

  const directconfirmForm = async (data: IndexValue) => {
    if (data) {
      await canjeService(data);
    }
  };

  const preconfirmForm = (data: IndexValue) => {
    setShowConfirmation(true);
    setFormCache(data);
  };

  const confirmForm = async () => {
    if (formCache) {
      closeConfirmation();
      await canjeService(formCache);
      setFormCache(undefined);
    }
  };

  const closeConfirmation = () => {
    setShowConfirmation(false);
    setFormCache(undefined);
  };

  return (
    <>
      <TemplateCanje title={CANJE_INVITADOS_TITLE(props.cantMaxInvitados)} message={msg}>
        <TemplateForm
          cantMaxima={props.cantMaxInvitados}
          textoBoton={CANJE_BUTTON_TEXT(invitados.length, props.cantMaxInvitados)}
          callback={invitados.length > 0 ? preconfirmForm : directconfirmForm}
          reset={true}
          controls={controls}
        >
          {invitados}
        </TemplateForm>
      </TemplateCanje>
      <InvitadosConfirmacion onAccept={confirmForm} onDecline={closeConfirmation} show={showConfirmation} onClose={closeConfirmation} />
    </>
  );
};
